import type { LaunchHero, OrbGreeting } from '../types';

export const INTRO =
  'Your Abekus copilot. Ask me anything, or tell me what to do: I can apply, register and enrol for you.';

/** The day's plan (POST /assistant/day-plan): one tap, a few targets across Abekus. */
export const HERO: LaunchHero = {
  action: 'Plan my day',
  caption:
    'A few quick wins for today, picked from your profile to get you hired faster.',
  continueAction: "Continue today's plan",
};

/** The orb's hello once a day: tapping it opens the launchpad and its plan. */
export const GREETING: OrbGreeting = {
  say: (name, firstEver) => ({
    key: 'daily',
    text: firstEver
      ? `Hi ${name}! I'm Abekus AI. Tap me and I'll plan your day to get you hired faster.`
      : `${name}, want a plan for today? I'll line up a few quick wins for you.`,
  }),
};
